import { Avatar, Skeleton, Table, TableCell, TableRow, Typography } from '@mui/material';
import { Box, Stack } from '@mui/system';
import React from 'react';

type Props = {};

const TherapPlanningLoadingPage = (props: Props) => {
  return (
    <>
      <Stack
        flexDirection="row"
        gap="1rem"
        sx={{ margin: '0px !important', overflow: 'auto' }}
      >
        <Stack
          sx={{ width: '100%', display: 'flex' }}
          direction={'row'}
          justifyContent={'space-around'}
          mt={2}
        >
          <Box sx={{ display: 'flex', width: '20%', alignItems: 'center', gap: 1 }}>
            <Typography
              width={'30%'}
              variant="h5"
            >
              <Skeleton animation="pulse" />
            </Typography>
            <Typography
              width={'100%'}
              variant="h5"
            >
              <Skeleton animation="pulse" />
            </Typography>
            <Skeleton
              animation="pulse"
              variant="circular"
            >
              <Avatar sx={{ width: 70, height: 70 }} />
            </Skeleton>
            <Typography
              width={'100%'}
              variant="h5"
            >
              <Skeleton animation="pulse" />
            </Typography>
            <Typography
              width={'30%'}
              variant="h5"
            >
              <Skeleton animation="pulse" />
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', width: '70%', alignItems: 'center', gap: 1 }}>
            <Typography
              width={'100%'}
              variant="h5"
            >
              <Skeleton animation="pulse" />
            </Typography>
            <Typography
              width={'100%'}
              variant="h5"
            >
              <Skeleton animation="pulse" />
            </Typography>
            <Typography
              width={'100%'}
              variant="h5"
            >
              <Skeleton animation="pulse" />
            </Typography>

            <Typography
              width={'30%'}
              variant="h5"
            >
              <Skeleton animation="pulse" />
            </Typography>
          </Box>
        </Stack>
      </Stack>
      <Stack
        flexDirection={'row'}
        justifyContent={'center'}
        alignItems={'center'}
        width={'100%'}
      >
        <Stack
          alignItems="center"
          justifyContent="center"
          width={'90%'}
          gap="1.5rem"
          sx={{ marginTop: '3rem' }}
        >
          {['1', '2', '3'].map((res) => {
            return (
              <Table key={res}>
                <TableRow key={res}>
                  {['1', '2', '3'].map((sle) => {
                    return (
                      <TableCell key={sle}>
                        <Box
                          sx={{
                            width: '100%',
                            display: 'flex',
                            justifyContent: 'space-between',
                          }}
                          key={sle}
                        >
                          <Typography
                            width={'100%'}
                            variant="h2"
                          >
                            <Skeleton animation={false} />
                          </Typography>
                        </Box>
                      </TableCell>
                    );
                  })}
                </TableRow>
              </Table>
            );
          })}
        </Stack>
      </Stack>
    </>
  );
};

export default TherapPlanningLoadingPage;
